PLAN_SKU_FOURTEEN_MONTHS_TO_ANNUAL_6